import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ReviewManagerDashboardPage from '@app/site/secured/review-manager/ReviewManagerDashboardPage';
import ReviewManagementInboxPage from '@app/site/secured/review-manager/fragment/reviews-inbox/ReviewManagementInboxPage';
import ReviewsPropertyOverviewPage from '@app/site/secured/review-manager/fragment/property-overview/ReviewsPropertyOverviewPage';
import ReviewsGroupOverviewPage
	from '@app/site/secured/review-manager/fragment/group-overview/ReviewsGroupOverviewPage';


const ReviewManagerRouter = React.memo(() => {
	return <Routes>
		<Route path="dashboard" element={<Navigate to="/secured/review-manager/inbox" replace />} />
		<Route element={<ReviewManagerDashboardPage />}>
			<Route path="inbox" element={<ReviewManagementInboxPage />} />
			<Route path="property-overview/*" element={<ReviewsPropertyOverviewPage />} />
			<Route path="group-overview/*" element={<ReviewsGroupOverviewPage />} />
		</Route>
	</Routes>;
});

export default ReviewManagerRouter;